import React, { forwardRef } from "react";

const STATUS = {
  RECEIVED: "Received",
};

const ProdAndSalePackingSlip = forwardRef(
  ({ packingSlipData, order, currentWarehouse, filterItem, totalQty }, ref) => {
    const formatDateTime = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    return (
      <div ref={ref}>
        <style>
          {`
            @media print {
              @page {
                margin: 8mm;
              }
            }
            
            .packing-slip-container {
              font-family: Arial, sans-serif;
              height: 100%;
              width: 100%;
              display: flex;
              flex-direction: column;
            }
            
            .label {
              font-weight: bold;
            }
            
            .label-header {
              text-align: center;
              font-weight: bold;
              font-size: 20px;
              text-decoration: underline;
              margin-bottom: 10px;
            }
            
            .defaultTitleSize {
              font-size: 14px;
            }
            
            .defaultSize {
              font-size: 12px;
            }
          `}
        </style>

        <div className="packing-slip-container">
          <div
            style={{
              position: "relative",
              height: "auto",
              pageBreakAfter: "always",
              width: "100%",
            }}
          >
            {/* Header */}
            <div className="label-header">
              PACKING SLIP(WEB){" "}
              {packingSlipData?.data?.shippingType &&
                packingSlipData?.data?.shippingType?.toUpperCase()}
            </div>

            {/* Watermark */}
            <div
              style={{
                position: "absolute",
                opacity: 0.3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <h2
                style={{
                  width: "100%",
                  position: "absolute",
                  opacity: 0.8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  top: "100%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                }}
              >
                {packingSlipData?.data?.toPay &&
                packingSlipData?.data?.paymentStatus === "POD Pending"
                  ? "भाड़ा तथा माल का पैसा लेना है"
                  : packingSlipData?.data?.toPay
                    ? `भाड़ा का पैसा लेना है\n${
                        packingSlipData?.data?.paymentStatus || ""
                      }`
                    : packingSlipData?.data?.paymentStatus === "POD Pending"
                      ? "माल का पैसा लेना है"
                      : packingSlipData?.data?.paymentStatus || ""}
              </h2>
            </div>

            {/* Main Content */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #000",
                borderBottom: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* Left Section */}
              <div
                style={{
                  width: "50%",
                  padding: "10px",
                  borderRight: "1px solid #000",
                  boxSizing: "border-box",
                }}
              >
                <div style={{ lineHeight: 1.4 }}>
                  <div
                    className="defaultTitleSize"
                    style={{ fontWeight: "bold" }}
                  >
                    {packingSlipData?.data?.storeName}/
                    {packingSlipData?.data?.name}
                  </div>
                  <div className="defaultSize">
                    {packingSlipData?.data?.address?.street}{" "}
                    {packingSlipData?.data?.address?.city},{" "}
                    {packingSlipData?.data?.address?.district}{" "}
                    {packingSlipData?.data?.address?.pincode}
                  </div>
                  <div className="defaultSize">
                    GSTIN: <strong>{order?.gstuin || ""}</strong>
                  </div>
                  <div className="defaultSize">
                    State: {packingSlipData?.data?.state}
                  </div>
                  <div className="defaultSize">
                    Contact: {packingSlipData?.data?.mobile}
                  </div>
                  <div className="defaultSize">
                    Email: {packingSlipData?.data?.email}
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div style={{ width: "50%", boxSizing: "border-box" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {/* Row 1 */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #000",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        borderRight: "1px solid #000",
                        padding: "10px",
                      }}
                    >
                      Voucher Id <br />
                      <span className="label">
                        {packingSlipData?.data?.voucherId}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        padding: "10px",
                      }}
                    >
                      Dated <br />
                      <span className="label">
                        {formatDateTime(packingSlipData?.data?.voucherDate)}
                      </span>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #000",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        borderRight: "1px solid #000",
                        padding: "10px",
                      }}
                    >
                      Delivery Method: <br />
                      <span className="label">
                        {/* {currentWarehouse?.courierName} */}
                        {packingSlipData?.data?.shippingInfo?.courierName}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        padding: "10px",
                      }}
                    >
                      Delivery Partner: <br />
                      <span className="label">
                        {/* {currentWarehouse?.partnerName} */}
                        {packingSlipData?.data?.shippingInfo?.partnerName}
                      </span>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #000",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        borderRight: "1px solid #000",
                        fontWeight: "bold",
                        padding: "10px",
                      }}
                    >
                      Total Amount:
                    </div>
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        padding: "10px",
                      }}
                      className="label"
                    >
                      {packingSlipData?.data?.totalAmount}
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        padding: "10px",
                        borderRight: "1px solid #000",
                      }}
                    >
                      Payment Method: <br />
                      <span className="label">
                        {packingSlipData?.data?.paymentMethod}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        textAlign: "left",
                        padding: "10px",
                      }}
                    >
                      {packingSlipData?.data?.paymentStatus === STATUS.RECEIVED
                        ? "Paid"
                        : "Pending"}{" "}
                      Amount: <br />
                      <span className="label">
                        {packingSlipData?.data?.paymentAmount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Items Table */}
            <div
              style={{
                border: "1px solid #000",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  borderBottom: "1px solid #000",
                }}
              >
                <div
                  style={{
                    width: "8%",
                    borderRight: "1px solid #000",
                    padding: "6px 0px",
                    textAlign: "center",
                  }}
                >
                  S.No.
                </div>
                <div
                  style={{
                    flex: 1,
                    borderRight: "1px solid #000",
                    padding: "6px",
                    textAlign: "center",
                  }}
                >
                  Description of Items
                </div>
                <div
                  style={{
                    width: "15%",
                    padding: "6px 0px",
                    textAlign: "center",
                  }}
                >
                  Quantity
                </div>
              </div>

              {/* Body */}
              <div
                style={{
                  minHeight: "350px",
                  overflowY: "visible",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                }}
              >
                {/* Full-height borders */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: "8%",
                    borderRight: "1px solid #000",
                    padding: "6px 0px",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: "15%",
                    borderRight: "1px solid #000",
                  }}
                />

                {/* Items */}
                {filterItem &&
                  filterItem.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "6px 0",
                      }}
                    >
                      {/* S.No. Column */}
                      <div
                        style={{
                          width: "8%",
                          textAlign: "center",
                          padding: "6px 0",
                        }}
                        className="label"
                      >
                        {index + 1}
                      </div>

                      {/* Description Column */}
                      <div
                        style={{ flex: 1, padding: "6px 8px" }}
                        className="label"
                      >
                        {/* Item Number */}
                        <div
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.itemNo}
                        </div>

                        {/* Description */}
                        {item?.desc && (
                          <div
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              marginTop: "4px",
                            }}
                          >
                            {item.desc}
                          </div>
                        )}
                      </div>

                      {/* Quantity Column */}
                      <div
                        style={{ width: "15%", textAlign: "center" }}
                        className="label"
                      >
                        {item?.qty} {item?.unit}
                      </div>
                    </div>
                  ))}
              </div>

              {/* Footer */}
              <div
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  borderTop: "1px solid #000",
                }}
              >
                <div
                  style={{
                    width: "8%",
                    padding: "6px 0px",
                    textAlign: "center",
                    borderRight: "1px solid #000",
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    textAlign: "right",
                    paddingRight: "8px",
                    borderRight: "1px solid #000",
                    padding: "6px",
                  }}
                >
                  Total
                </div>
                <div
                  style={{
                    width: "15%",
                    textAlign: "center",
                    padding: "6px 0px",
                  }}
                >
                  {totalQty}
                </div>
              </div>
            </div>

            {/* Footer Section */}
            <div
              style={{
                border: "1px solid #000",
                borderTop: "none",
                borderCollapse: "collapse",
              }}
            >
              {/* Total Number of Packages */}
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <h4>Total Number of Packages:</h4>
                  <div
                    style={{
                      border: "1px solid #000",
                      height: "30px",
                      width: "150px",
                      borderRadius: "5px",
                    }}
                  />
                </div>
              </div>

              {/* Packed By and Checked By */}
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h4 style={{ margin: 0 }}>Packed By: &nbsp;&nbsp;&nbsp;</h4>
                    <div
                      style={{
                        border: "1px solid #000",
                        height: "30px",
                        width: "150px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h4 style={{ margin: 0 }}>
                      Checked By: &nbsp;&nbsp;&nbsp;
                    </h4>
                    <div
                      style={{
                        border: "1px solid #000",
                        height: "30px",
                        width: "150px",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Comment Section */}
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h4>Comment (if any):</h4>
                  <div
                    style={{
                      border: "1px solid #000",
                      width: "500px",
                      height: "30px",
                      borderRadius: "5px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
export default ProdAndSalePackingSlip;
